import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

// @TODO: line 8, This will produce an error if trails < 1

const BreadCrumbs = ({ trails }) => {
  if (!trails.length) return <></>
  return (
    <div className="bread-crumbs text-xs lg:text-base flex items-center justify-start lato-reg text-primary-lightgray">
      <a className="block lg:hidden text-lg" href={trails[trails.length - 2]?.url}>
        {trails[trails.length - 2]?.title}
      </a>
      <span className="hidden lg:block">
        {trails.map((trail, key) => (
          <Fragment key={key}>
            <a key={key} href={trail.url}>
              {trail.title}
            </a>
            {trails.length - 1 > key && (
              <i className="fa fa-angle-right mx-2" aria-hidden="true"></i>
            )}
          </Fragment>
        ))}
      </span>
    </div>
  )
}

BreadCrumbs.propTypes = {
  trails: PropTypes.arrayOf(PropTypes.object),
}

export default BreadCrumbs
